import { render } from "./ProductMarketingPage.vue?vue&type=template&id=991bd8e2"
import script from "./ProductMarketingPage.vue?vue&type=script&lang=js"
export * from "./ProductMarketingPage.vue?vue&type=script&lang=js"
script.render = render

export default script